// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  campaignId: __t.string().name("campaign_id"),
  accountId: __t.string().name("account_id"),
  username: __t.string(),
  token: __t.string(),
  tokenExpiresAt: __t.timestamp().name("token_expires_at"),
  hasDeployed: __t.bool().name("has_deployed"),
  eliminated: __t.bool(),
  pendingDeploy: __t.bool().name("pending_deploy"),
  sequence: __t.u64(),
  armyIndex: __t.u32().name("army_index"),
});
